var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-async-promise-executor */
/* eslint-disable camelcase */
import { AppHelper } from '../helpers/env-helper';
import { UrlHelper } from '../helpers/url-helper';
import { AUTH_MESSAGES } from '../messages/auth/auth-messages';
import axios from 'axios';
import { environment } from '../environments/environment';
import { LocalStorageService } from './local-storage.service';
import { URL_BASE_PLURI_CONNECT_TROCAR_SENHA } from '../constants/url';
import { CommunicationService } from './communication.service';
import { ClientService } from './client.service';
var AuthService = /** @class */ (function () {
    function AuthService() {
        this.clientService = ClientService.singleton();
        this.urlHelper = new UrlHelper();
        this.localStorage = LocalStorageService.singleton();
        this.axios = axios.create({
            baseURL: environment.pluriConnect.back
        });
    }
    AuthService.prototype.recoverUserFromLocalStorage = function () {
        this.localStorage.setSystemAtivoToken(this.getAppHashByUrl());
        var user = this.localStorage.getItem('usua_perfil_ativo');
        return {
            success: true,
            message: AUTH_MESSAGES.success_auth_storage,
            data: user
        };
    };
    AuthService.prototype.getAppByUrl = function () {
        return AppHelper.getAppHashByAppName(this.urlHelper.getAppName(window.location.href));
    };
    AuthService.prototype.getAppHashByUrl = function () {
        var _a;
        return (_a = this.getAppByUrl()) === null || _a === void 0 ? void 0 : _a.chave_sistema;
    };
    AuthService.prototype.updateLocalStorageAuthData = function (authParams, user) {
        var token = authParams.token, chave_sistema = authParams.chave_sistema;
        this.localStorage.setItem(chave_sistema, __assign(__assign({}, user), { token: token }), true);
    };
    AuthService.prototype.recoverUserFromApi = function (authParams) {
        return __awaiter(this, void 0, void 0, function () {
            var requestUser, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!authParams.chave_sistema || authParams.chave_sistema === '@@chaveSistema@@') {
                            authParams.chave_sistema = this.getAppHashByUrl();
                        }
                        return [4 /*yield*/, this.user(authParams)];
                    case 1:
                        requestUser = _a.sent();
                        user = requestUser.data.data;
                        this.updateLocalStorageAuthData(authParams, user);
                        return [2 /*return*/, {
                                success: true,
                                message: AUTH_MESSAGES.success_auth_api,
                                data: user
                            }];
                }
            });
        });
    };
    AuthService.prototype.init = function () {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var params, hash, authParams, user, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, , 5]);
                        params = window.location.search;
                        if (!params) {
                            hash = window.location.hash;
                            params = hash.slice(hash.indexOf('?'));
                        }
                        authParams = this.urlHelper.paramsUrl(params);
                        if (authParams.app_view) {
                            CommunicationService.singleton().emitCustomEvent('setAppView', authParams.app_view);
                            localStorage.setItem('app_view', authParams.app_view);
                        }
                        if (!(!authParams.token || authParams.token === 'undefined' || authParams.token === 'null')) return [3 /*break*/, 1];
                        user = this.recoverUserFromLocalStorage();
                        if (user.data) {
                            return [2 /*return*/, resolve(user)];
                        }
                        return [2 /*return*/, resolve({
                                success: true,
                                message: AUTH_MESSAGES.success_auth_storage,
                                data: null
                            })];
                    case 1:
                        if (window.location.pathname.indexOf(URL_BASE_PLURI_CONNECT_TROCAR_SENHA) !== -1) {
                            return [2 /*return*/, resolve({
                                    success: true,
                                    message: AUTH_MESSAGES.success_auth_storage,
                                    data: null
                                })];
                        }
                        _a = resolve;
                        return [4 /*yield*/, this.recoverUserFromApi(authParams)];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.log(error_1);
                        this.localStorage.clear();
                        reject({
                            success: false,
                            message: AUTH_MESSAGES.error,
                            data: error_1
                        });
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
    };
    AuthService.prototype.logout = function () {
        CommunicationService.singleton().emitCustomEvent('requestLogout', null);
    };
    AuthService.prototype.user = function (authParams) {
        return this.axios.get('/v2/usuarios', this.getRequestParams(authParams));
    };
    AuthService.prototype.userProfile = function (authParams) {
        return this.axios.get('/v2/usuarios', this.getRequestParams(authParams));
    };
    AuthService.prototype.getRequestParams = function (authParams) {
        var appData = AppHelper.getAppByAppHash(authParams.chave_sistema);
        var params = {
            usua_tipo_id: authParams.usua_tipo_id || authParams.usua_perfil,
            parc_perf_id: authParams.parc_perf_id || 0,
            chave_sistema: appData.chave_autenticacao || authParams.chave_sistema,
            rotina_curta: 1,
            subdominio: this.clientService.subdomain
        };
        var headers = {
            Authorization: authParams.token,
            'Inst-Codigo': authParams.inst_codigo
        };
        return { params: params, headers: headers };
    };
    return AuthService;
}());
export { AuthService };
